// Used in assignment-uploads.component.html

import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: "no-assignment-uploads",
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ["./no-assignment-uploads.component.scss"],
    template: `
        <div class="no-upload-results">
            <div>
                <p>No Assignment Files Uploaded</p>
            </div>
        </div>
    `,
    standalone: false
})
export class NoAssignmentUploadsComponent {
    constructor() {}
}
